import { schema } from 'normalizr';
import userSchema from './user_schema';

const assetSchema = new schema.Entity('assets', {
  created_by: userSchema,
});

export default assetSchema;
